import { render } from "./PolarAuthRedirect.vue?vue&type=template&id=563a60ae"
import script from "./PolarAuthRedirect.vue?vue&type=script&lang=ts"
export * from "./PolarAuthRedirect.vue?vue&type=script&lang=ts"
script.render = render

export default script